// import React from "react";
// import {
//   File as FileIcon,
//   FileText,
//   FileSpreadsheet,
//   FileArchive,
//   FileImage,
//   FileVideo,
//   FileAudio,
//   FileCode,
//   Globe,
//   Youtube,
// } from "lucide-react";

// export const getFileIcon = (item, size = 20) => {
//   const name = item?.name || "";
//   const ext = (
//     item?.fileExtension ||
//     name.split(".").pop() ||
//     ""
//   ).toLowerCase();

//   const type = (item?.fileType || "").toLowerCase();

//   // Images
//   if (
//     ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "svg"].includes(ext)
//   ) {
//     return <FileImage size={size} className="repo-file-icon" />;
//   }

//   // Audio
//   if (
//     ["mp3", "wav", "aac", "flac"].includes(ext) ||
//     type.includes("audio")
//   ) {
//     return <FileAudio size={size} className="repo-file-icon" />;
//   }

//   // Video
//   if (
//     ["mp4", "mov", "avi", "mkv", "flv", "wmv"].includes(ext) ||
//     type.includes("video")
//   ) {
//     return <FileVideo size={size} className="repo-file-icon" />;
//   }

//   // ZIP
//   if (["zip", "rar", "7z"].includes(ext)) {
//     return <FileArchive size={size} className="repo-file-icon" />;
//   }

//   // Excel
//   if (["xls", "xlsx", "csv"].includes(ext)) {
//     return <FileSpreadsheet size={size} className="repo-file-icon" />;
//   }

//   // PowerPoint
//   if (["ppt", "pptx"].includes(ext)) {
//     return <FileText size={size} className="repo-file-icon" />;
//   }

//   // Word / Text / PDF / MSG
//   if (
//     [
//       "pdf",
//       "doc",
//       "docx",
//       "txt",
//       "rtf",
//       "odt",
//       "msg",
//     ].includes(ext)
//   ) {
//     return <FileText size={size} className="repo-file-icon" />;
//   }

//   // YouTube
//   if (
//     type.includes("youtube") ||
//     ext === "youtube" ||
//     name.includes("youtube.com") ||
//     name.includes("youtu.be")
//   ) {
//     return (
//       <Youtube
//         size={size}
//         className="repo-file-icon"
//         style={{ color: "#FF0000" }}
//       />
//     );
//   }

//   // Web Pages
//   if (
//     type === "webpage" ||
//     ext === "webpage" ||
//     name.startsWith("http")
//   ) {
//     return <Globe size={size} className="repo-file-icon" />;
//   }

//   // Code Files
//   if (
//     [
//       "js",
//       "jsx",
//       "ts",
//       "tsx",
//       "html",
//       "css",
//       "scss",
//       "json",
//       "xml",
//       "yml",
//       "yaml",
//     ].includes(ext)
//   ) {
//     return <FileCode size={size} className="repo-file-icon" />;
//   }

//   // Default
//   return <FileIcon size={size} className="repo-file-icon" />;
// };

//icons with the color

import React from "react";
import {
  Globe,
  File as FileIcon,
} from "lucide-react";

import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileArchive,
  FaFileImage,
  FaFileVideo,
  FaFileAudio,
  FaFileAlt,
} from "react-icons/fa";

import {
  SiYoutube,
  SiJavascript,
  SiHtml5,
  SiCss3,
} from "react-icons/si";

export const getFileIcon = (item, size = 20) => {
  const name = item?.name || "";

  const ext = (
    item?.fileExtension ||
    name.split(".").pop() ||
    ""
  ).toLowerCase();

  const type = (item?.fileType || "").toLowerCase();

  // PDF
  if (ext === "pdf") {
    return <FaFilePdf size={size} color="#4DABF7" />;
  }

  // Word
  if (["doc", "docx"].includes(ext)) {
    return <FaFileWord size={size} color="#4DABF7" />;
  }

  // Excel
  if (["xls", "xlsx"].includes(ext)) {
    return <FaFileExcel size={size} color="#4DABF7" />;
  }

  // PowerPoint
  if (["ppt", "pptx"].includes(ext)) {
    return <FaFilePowerpoint size={size} color="#4DABF7" />;
  }

  // ZIP
  if (["zip", "rar", "7z"].includes(ext)) {
    return <FaFileArchive size={size} color="#4DABF7" />;
  }

  // Images
  if (
    ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "svg"].includes(ext)
  ) {
    return <FaFileImage size={size} color="#4DABF7" />;
  }

  // Audio
  if (
    ["mp3", "wav", "aac", "flac"].includes(ext) ||
    type.includes("audio")
  ) {
    return <FaFileAudio size={size} color="#4DABF7" />;
  }

  // Video
  if (
    ["mp4", "mov", "avi", "mkv", "flv", "wmv"].includes(ext) ||
    type.includes("video")
  ) {
    return <FaFileVideo size={size} color="#4DABF7" />;
  }

  // YouTube
  if (
    type.includes("youtube") ||
    name.includes("youtube.com") ||
    name.includes("youtu.be")
  ) {
    return <SiYoutube size={size} color="#4DABF7" />;
  }

  // Webpage
  if (
    type === "webpage" ||
    ext === "webpage" ||
    name.startsWith("http")
  ) {
    return <Globe size={size} color="#4DABF7" />;
  }

  // JavaScript
  if (["js", "jsx"].includes(ext)) {
    return <SiJavascript size={size} color="#4DABF7" />;
  }

  // HTML
  if (["html", "htm"].includes(ext)) {
    return <SiHtml5 size={size} color="#4DABF7" />;
  }

  // CSS
  if (["css", "scss"].includes(ext)) {
    return <SiCss3 size={size} color="#4DABF7" />;
  }

  // Text / MSG
  if (["txt", "msg"].includes(ext)) {
    return <FaFileAlt size={size} color="#4DABF7" />;
  }

  // Default
  return <FileIcon size={size} className="repo-file-icon" />;
};